import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import { CASTE_CODES, FEMALE, MALE, NO_RECORDS_FOUND } from '../../../../../utils/constants';
import { AppUtils } from '../../../../../utils/appUtils';
import { Delete, Done, Edit, Print } from '@mui/icons-material';
import { AppMisc } from '../../../../../misc/appMisc';
import { DISEASE, ICD_CODE_OPTIONS, IMPROVEMENT_STATUS, NEW_PATIENT, PREVIOUS_PATIENT, TREATMENT_STATUS } from '../../../../../utils/constants/forms';
import ReactToPrint from "react-to-print";

const NcdRegister = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      if (page) {
        setMainRegisterData(prev => {
          return [...prev, ...props.tableData]
        })
      } else {
        tableRef.current.scrollTo(0, 0)
        setMainRegisterData(props.tableData)
      }
    }
  }, [props.tableData])

  const fetchData = () => {
    props.handleChangePage(page + 1);
    props.getTableData(true)
  }

  return (
    <>
      <InfiniteScroll
        dataLength={mainRegisterData?.length}
        next={fetchData}
        hasMore={mainRegisterData?.length !== totalSize}
        loader={<p style={{ textAlign: 'center' }} className="print-none">Loading....</p>}
        scrollableTarget="mul-dartaa-register"
      >
        <ReactToPrint
          trigger={() => (
            <Box display={"flex"} justifyContent={"flex-end"}>
              <IconButton>
                <Print />
              </IconButton>
            </Box>
          )}
          content={() => tableRef.current}
        />
        <TableContainer classes={{ root: "fixed-head-table-container" }}  >
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register" ref={tableRef}>
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell rowSpan={2}>क्र.सं</TableCell>
                <TableCell rowSpan={2}>दर्ता मिति</TableCell>
                <TableCell colSpan={2}>दर्ता नम्बर</TableCell>
                <TableCell colSpan={2}>सेवाग्राहीको</TableCell>
                <Tooltip title=
                  {
                    <>
                      {CASTE_CODES.map(caste => (
                        <Typography key={caste.value} variant="caption"> {caste.label} </Typography>
                      ))}
                    </>
                  }
                  placement="top"
                  arrow
                >
                  <TableCell rowSpan={2}>जाती कोड</TableCell>
                </Tooltip>
                <TableCell colSpan={2}>उमेर</TableCell>
                <TableCell colSpan={5}>ठेगाना</TableCell>
                <TableCell rowSpan={2}>राष्ट्रिय परिचयपत्र नम्वर</TableCell>
                <TableCell rowSpan={2}>सम्पर्क नम्बर</TableCell>
                <TableCell rowSpan={2}>आईसिडि कोड</TableCell>
                <TableCell rowSpan={2}>रोग</TableCell>
                <TableCell rowSpan={2}>निदानात्मक परीक्षण</TableCell>
                <TableCell rowSpan={2}>सम्भावित निदान</TableCell>
                <TableCell colSpan={4}>उपचार र सल्लाह</TableCell>
                <TableCell rowSpan={2}>मृत्यु भएको </TableCell>
                <TableCell colSpan={2}>पुराना सेवाग्राहीहरुको लागि मात्र</TableCell>
                <TableCell colSpan={2}>प्रेषण भई</TableCell>
                <TableCell rowSpan={2} className="print-none" >सम्पादन</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>पहिलो पटक</TableCell>
                <TableCell>थप पटक</TableCell>
                <TableCell>नाम</TableCell>
                <TableCell>थर</TableCell>
                <TableCell>महिला</TableCell>
                <TableCell>पुरुष</TableCell>
                <TableCell>जिल्ला</TableCell>
                <TableCell>नगर/गाउँपालिका</TableCell>
                <TableCell>वडा नं.</TableCell>
                <TableCell>टोल</TableCell>
                <TableCell>अन्य मुलुक</TableCell>
                <TableCell>औषधि</TableCell>
                <TableCell>मनोसामाजिक</TableCell>
                <TableCell>परामर्श</TableCell>
                <TableCell>अन्य</TableCell>
                <TableCell>उपचार नियमितता</TableCell>
                <TableCell>सुधारको अवस्था</TableCell>
                <TableCell>आएको संस्थाको नाम</TableCell>
                <TableCell>गएको संस्थाको नाम</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {
                mainRegisterData?.length > 0 ? (
                  mainRegisterData.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                      <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                      <TableCell>{row?.patientType === NEW_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                      <TableCell>{row?.patientType === PREVIOUS_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                      <TableCell>{row?.patientFirstName || "-"}</TableCell>
                      <TableCell>{row?.patientLastName || "-"}</TableCell>
                      <TableCell>{row?.casteCode && AppUtils.replaceWithNepaliDigit(row.casteCode) || "-"}</TableCell>
                      <TableCell>{row?.gender === FEMALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                      <TableCell>{row?.gender === MALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                      <TableCell>{row?.district && AppMisc.getDistrictName(row?.district)}</TableCell>
                      <TableCell>{row?.palikaName && AppMisc.getMunicipalityName(row?.palikaName)}</TableCell>
                      <TableCell>{row?.wardNumber && AppUtils.replaceWithNepaliDigit(row?.wardNumber)}</TableCell>
                      <TableCell>{row?.gaunOrTole || "-"}</TableCell>
                      <TableCell>{row?.otherCountry ? <Done /> : "-"}</TableCell>
                      <TableCell>{row?.nid || "-"}</TableCell>
                      <TableCell>{row?.phoneNumber && AppUtils.replaceWithNepaliDigit(row?.phoneNumber)}</TableCell>
                      <TableCell>{AppMisc.getLabelFromValues(ICD_CODE_OPTIONS, row?.icdCode || "-")}</TableCell>
                      <TableCell>{AppMisc.findLabelFromValue(DISEASE, row.disease)}</TableCell>
                      <TableCell>{row.diagnosisTest || "-"}</TableCell>
                      <TableCell>{row.possibleDiagnosis || "-"}</TableCell>
                      <TableCell>{row.medicine || "-"}</TableCell>
                      <TableCell>{row.mentalConsultation || "-"}</TableCell>
                      <TableCell>{row.paramarsa || "-"}</TableCell>
                      <TableCell>{row.others || "-"}</TableCell>
                      <TableCell>{row.died ? <Done /> : "-"}</TableCell>
                      <TableCell>{AppMisc.findLabelFromValue(TREATMENT_STATUS, row.treatmentStatus || "-")}</TableCell>
                      <TableCell>{AppMisc.findLabelFromValue(IMPROVEMENT_STATUS, row.improvementStatus || "-")}</TableCell>
                      <TableCell>{row.referredIn || "-"}</TableCell>
                      <TableCell>{row.referredOut || "-"}</TableCell>
                      <TableCell className="print-none">
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                            <Edit fontSize="small" />
                          </IconButton>
                          <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                            <IconButton onClick={() => props.deleteRow(row.id)}>
                              <Delete fontSize="small" color='secondary' />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="31" size="medium">{NO_RECORDS_FOUND}</TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>
    </>
  )
}

export default NcdRegister;